// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"73":"7b9057a3","352":"af162cb7","407":"af58d805","652":"c04411a4","835":"a65533d7","885":"c5c2cbc7"}[chunkId] + ".chunk.js";
};